import { LoadingService } from './../../../services/loading.service';
import {Component, OnInit} from '@angular/core';
import {ApiService, UserInfo} from "../../../services/api.service";
import {Router} from "@angular/router";
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@components/components.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '@components/button/button.component';
import { InputComponent } from '@components/input/input.component';
import { ClaimCardComponent } from '../claim-card/claim-card.component';
import { NewClaimComponent } from '../new-claim/new-claim.component';
import { Claim } from 'app/interfaces/claim.interface';

    export interface ClaimListResponse {
            claims: Claim[]
            hasNextPage: boolean
        }
@Component({
    selector: 'app-claim-list',
    templateUrl: './claim-list.component.html',
    styleUrl: './claim-list.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        ComponentsModule,
        TranslateModule,
        ButtonComponent,
        InputComponent,
        ClaimCardComponent,
        NewClaimComponent
    ]
})
export class ClaimListComponent implements OnInit {
    loading: boolean = true
    claims: Claim[] | null
    // projectListResponse: ClaimListResponse
    userInfo: UserInfo
    index: number = 1
    // FILTERS
    status: string | null = null
    dateType: string = 'createdAt'
    dateFrom: string | null = null // new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
    dateTo: string | null = null // new Date().toISOString().slice(0, 10)
    page: number = 0
    size: number = 10
    sort: string = 'id,desc'
    search: string = ''
    searchSubject = new Subject<void>()
    hasNextPage: boolean = false

    firstLoading = true

    constructor(private api: ApiService, private router: Router, private loadingService: LoadingService, private translate: TranslateService) {}

    ngOnInit(): void {
        this.fetchClaims()
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            this.page = 0

        // this.searchSubject.pipe(debounceTime(300)).subscribe(() => {
        //     this.page = 0
        //     this.fetchClaims()
        // })


        })
    }

    filterSearch(searchInput: string, keyPressed = false) {
        this.search = searchInput
        this.searchSubject.next()
        this.fetchClaims()
    }
    filterClaims(status: string | null) {
        this.status = status
        this.page = 0
        this.fetchClaims()
    }

    nextPage() {
        this.page++
        this.fetchClaims()
    }
    shouldShowNextButton() {
        // return !this.loading && this.projects != null && this.page < this.projectListResponse.totalPages - 1
        return this.hasNextPage
    }
    fetchClaims() {
        this.loadingService.show()

        if (this.page == 0) {
            this.claims = null
        }

        let filterBody: Record<string, string | number | null> = {
            status: this.status,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            page: this.page,
            size: this.size,
            sort: this.sort,
            search: this.search,
        }
        // Filtrar los pares clave-valor que tengan valor nulo
        const filteredParams = Object.entries(filterBody)
            .filter(([key, value]) => value !== null)
            .reduce((obj, [key, value]) => {
                if (value !== null) {
                    obj[key] = value as string; // Type assertion to string
                }
                return obj
            }, {} as Record<string, string>)


        
        this.api.getClaimList(filteredParams).subscribe((response: ClaimListResponse) => {
            if (this.page != 0) {
                this.claims = this.claims ? this.claims.concat(response.claims) : response.claims
            } else {
                this.claims = response.claims
            }
            this.hasNextPage = response.hasNextPage
            this.loadingService.hide()

        })
    }

    goToCreateClaim() {
        this.router.navigate(['create-claim'])
    }
    loadCustomTranslations() {
        this.translate.get([
            "my_claims.draft",
            "my_claims.pending_approval",
            "my_claims.pending_information",
            "my_claims.in_progress",
            "my_claims.completed",
            "my_claims.closed",
            "my_claims.duplicate",
            "my_claims.denied",
            "my_claims.pending_restoration",
            "my_claims.not_restored",
            "my_claims.restored",
            "my_claims.process_finished",
            "my_claims.on_hold",
            "my_claims.escalated",
            "my_claims.review",
            "my_claims.pending_user_validation",
            "my_claims.pending_user_information",
            "my_claims.solved",
            "my_claims.backlog",
            "my_claims.in_development",
            "my_claims.included_hotfix",
            "my_claims.returned",
            "my_claims.reassigned_review",
            "my_claims.visit_pending",
            "my_claims.does_not_apply",
            "my_claims.stopped",
            "my_claims.system_error",
            "my_claims.dismissed",
            "my_claims.pending_deployment",
            "my_claims.typology_category_COSENTINO_CENTER",
            "my_claims.typology_category_INSTALLED",
            "my_claims.typology_category_FABRICATOR_INSTALLER_BUILDER",
            "my_claims.typology_category_TRANSIT_CENTER_CENTER",
            "my_claims.typology_category_TRANSIT_CENTER_CUSTOMER",
            "my_claims.typology_category_TRANSIT_CUSTOMER_CUSTOMER",
            "my_claims.typology_category_TRANSIT_HQ_CENTER",
            "my_claims.typology_category_TRANSIT_HQ_CUSTOMER",
            "my_claims.typology_origin_LABOUR",
            "my_claims.typology_origin_CUT_TO_SIZE",
            "my_claims.typology_origin_PROLINE",
            "my_claims.typology_origin_PRODUCT_PORTFOLIO",
            "my_claims.typology_origin_SLAB"
        ]);
        
    }
}
